import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-empty-page',
  imports: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './empty-page.html',
})
export class EmptyPage {}
